"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Rocket, RefreshCw, X } from "lucide-react";
import { toast } from "../toast"; // 假设这是你的 toast 路径

// 扩展 Window 接口以支持 workbox
declare global {
  interface Window {
    workbox: any;
  }
}

export function PwaUpdater() {
  const [updateWaiting, setUpdateWaiting] = useState<boolean>(false);

  useEffect(() => {
    // 确保在客户端环境且支持 Service Worker
    if (
      typeof window !== "undefined" &&
      "serviceWorker" in navigator &&
      window.workbox !== undefined
    ) {
      const wb = window.workbox;

      const promptUserToUpdate = () => {
        setUpdateWaiting(true);
        // 触发一个轻量级的 toast 提示
        toast({
          type: 'success',
          description: "发现新版本，请刷新以应用更新。",
        });
      };

      // 监听等待激活的 Service Worker
      wb.addEventListener("waiting", promptUserToUpdate);

      // 注册 Service Worker
      wb.register();
    }
  }, []);

  const handleUpdate = () => {
    if (
      typeof window !== "undefined" &&
      "serviceWorker" in navigator &&
      window.workbox !== undefined
    ) {
      const wb = window.workbox;

      // 监听 controlling 事件：当新的 SW 接管页面时触发
      wb.addEventListener("controlling", () => {
        window.location.reload();
      });

      // 发送消息跳过等待
      wb.messageSkipWaiting();
    }
  };

  if (!updateWaiting) {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-[200] w-full max-w-[380px] animate-in fade-in slide-in-from-bottom-10 duration-500">
      {/* 自定义卡片容器 */}
      <div className="relative overflow-hidden rounded-xl border border-slate-200 bg-white p-5 shadow-2xl dark:border-slate-800 dark:bg-slate-950">
        {/* 装饰性背景 */}
        <div className="absolute -right-4 -top-4 h-24 w-24 rounded-full bg-blue-500/10 blur-2xl" />
        
        <div className="flex items-start gap-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900/30">
            <Rocket className="h-5 w-5 text-blue-600 dark:text-blue-400" />
          </div>
          
          <div className="flex-1">
            <h3 className="text-sm font-bold text-slate-900 dark:text-slate-100">
              发现新版本
            </h3>
            <p className="mt-1 text-sm leading-relaxed text-slate-500 dark:text-slate-400">
              应用已准备好更新，点击下方按钮立即体验最新版本。
            </p>
            
            <div className="mt-4 flex items-center gap-2">
              <Button 
                onClick={handleUpdate} 
                size="sm" 
                className="h-9 w-full bg-blue-600 font-medium text-white hover:bg-blue-500 dark:bg-blue-500 dark:hover:bg-blue-400"
              >
                <RefreshCw className="mr-2 h-3.5 w-3.5" />
                立即刷新
              </Button>
              
              {/* 允许用户暂时关闭提示 */}
              <Button
                onClick={() => setUpdateWaiting(false)}
                variant="ghost"
                size="sm"
                className="h-9 px-3 text-slate-400 hover:text-slate-600"
              >
                稍后
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
